import React, { useState, useEffect, useContext } from "react";
import LocatorServices from "../services";
import LocatorSearch from "./locator-search";
import LocatorMapContainer from "./locator-map-container";

import { validatePostalCode } from "../utils";
import useTrans from "../utils/use-trans";
import { AppContext } from "../app-context";
import { LocationContext } from "../context/LocationContext";


interface AppLocalService {
  language: any;
  trackingService: any;
  search_type: string | null;
}

const LocatorApp: React.FC<AppLocalService> = ({ language, trackingService, search_type = null }) => {

  const appContext = useContext(AppContext);

  const [dealers, setDealers] = useState([]);
  const [center, setCenter] = useState<google.maps.LatLng | google.maps.LatLngLiteral | undefined>(undefined);
  const [currentLocale, setCurrentLocale] = useState("en");
  const [invalidZip, setInvalidZip] = useState(false);
  const [searchMade, setSearchMade] = useState(false);
  const service = new LocatorServices();
  const locationCtx = useContext(LocationContext);

  const trans = useTrans();

  const [labels, setLabels] = useState(trans);

  let dealerBaseUrl = appContext.globalApi + '/dealers?tire_storage=true&limit=10';

  if(search_type == "Repair Facility") {
    dealerBaseUrl = appContext.globalApi + "/dealers?collision_centre=true&limit=10";
  }

  const _searchHandler = async (postalCode?: string) => {
    let response: any;
    try {
      const validated = validatePostalCode(postalCode as string);
      if (postalCode) {
        if (validated) {
          locationCtx?.set(postalCode);
          setInvalidZip(false);
          response = await service.getPoints(dealerBaseUrl, postalCode);
        } else {
          setInvalidZip(true);
        }
      } else {
        response = await service.getPoints(dealerBaseUrl);
      }

      if (response) {
        setDealers([]);
        setDealers(response.parsedBody.data);
        setCenter({
          lat: parseFloat(response.parsedBody.data[0].latitude),
          lng: parseFloat(response.parsedBody.data[0].longitude),
        });
      }
    } catch (e) {
      setInvalidZip(true);
    }
  };

  const _inputChangeHandler = (event: any, postalCode?: string) => {
    if (event.type === "keydown") {
      setInvalidZip(false);
      if (event.which === 13) {
        setSearchMade(true);
        _searchHandler(postalCode);
      }
    } else if (event.type === "click") {
      setSearchMade(true);
      _searchHandler(postalCode);
    }
  };

  useEffect(() => {
    let labelsLanguage = trans;
    setLabels(labelsLanguage);
    setCurrentLocale(language["language"] === "fr" ? "fr" : "en");
    setInvalidZip(false);
  }, [language]);

  return (
    <div className="App">
      <LocatorSearch
        initialPostalCodeValue={locationCtx?.value}
        postalCodeLabel={labels.postalCodeLabel}
        searchLabel={labels.searchLabel}
        postalCodeError={labels.postalCodeError}
        postalCodePlaceholder={labels.postalCodePlaceholder}
        invalidZip={invalidZip}
        inputOnChange={_inputChangeHandler}
        tracking={trackingService}
      />
      <LocatorMapContainer
        dealers={dealers}
        center={center}
        requestLabel={labels.requestLabel}
        currentLocale={currentLocale}
        searchMade={searchMade}
        invalidZip={invalidZip}
        placeholderDealersHeadline={labels.placeHolderDealersHeadline}
        searchCallback={_searchHandler}
        tracking={trackingService}
        secretBaseUrl={appContext.secretBaseUrl}
      />
    </div>
  );
};

export default LocatorApp;
